import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AlertTriangle, Home, ArrowLeft, RefreshCw } from 'lucide-react';

interface ErrorPageProps {
  statusCode?: number;
  title?: string;
  message?: string;
  standalone?: boolean;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ 
  statusCode = 500, 
  title = 'Erro interno do servidor', 
  message = 'Ocorreu um erro inesperado ao processar sua solicitação.',
  standalone = false
}) => {
  let navigate;
  try {
    navigate = useNavigate();
  } catch (error) {
    // useNavigate falhou, provavelmente porque estamos fora do contexto do Router
    navigate = null;
  }

  const handleGoBack = () => {
    if (navigate) {
      navigate(-1);
    } else {
      window.history.back();
    }
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-12 bg-gray-50">
      <div className="text-center max-w-lg w-full bg-white rounded-lg shadow-md p-8">
        <div className="flex justify-center mb-6">
          <div className="h-20 w-20 rounded-full bg-red-100 flex items-center justify-center">
            <AlertTriangle className="h-10 w-10 text-red-500" />
          </div>
        </div>
        
        <h1 className="text-2xl font-bold text-gray-800 mb-2">{statusCode} - {title}</h1>
        
        <p className="text-gray-600 mb-8">{message}</p>
        
        <div className="flex flex-col md:flex-row gap-4 justify-center">
          <button
            onClick={handleGoBack}
            className="flex items-center justify-center gap-2 px-4 py-2 rounded-md bg-gray-100 text-gray-700 hover:bg-gray-200 transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Voltar
          </button>
          
          <button
            onClick={handleRefresh}
            className="flex items-center justify-center gap-2 px-4 py-2 rounded-md bg-blue-100 text-blue-700 hover:bg-blue-200 transition-colors"
          >
            <RefreshCw className="h-4 w-4" />
            Tentar novamente
          </button>
          
          {!standalone ? (
            <Link
              to="/"
              className="flex items-center justify-center gap-2 px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors"
            >
              <Home className="h-4 w-4" />
              Página inicial
            </Link>
          ) : (
            <a
              href="/"
              className="flex items-center justify-center gap-2 px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors"
            >
              <Home className="h-4 w-4" />
              Página inicial
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorPage; 